module.exports = __webpack_public_path__ + "media/rental-comparison.07f74b88.webp";